import React from 'react';
import { IProps, IAccordionItem } from 'components/Home/FlowRemind/Remind/types';
import Accordion from 'components/Accordion';

const Remind: React.FC<IProps> = (props) => (
  <div className="flow-remind__remind-section">
    <div className="flow-remind__remind-container">
      {props.title && (
        <div className="flow-remind__remind-title">溫馨提醒</div>
      )}
      <div className="flow-remind__remind-content">
        {props.children}
      </div>
      {props.accordion && (
        <Accordion>
          {props.accordion.map((item: IAccordionItem, index: number) => (
            <Accordion.Item key={index}>
              <Accordion.Header title={item.title} />
              <Accordion.Content>{item.content}</Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion>
      )}
    </div>
  </div>
);

export default Remind;
